export const olimpoBanner = 'https://static.piramide.tv/img/oh_brand.gif';
